import { render, staticRenderFns } from "./16.12Record.vue?vue&type=template&id=0ec82400&scoped=true&"
import script from "./16.12Record.vue?vue&type=script&lang=js&"
export * from "./16.12Record.vue?vue&type=script&lang=js&"
import style0 from "./16.12Record.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./16.12Record.vue?vue&type=style&index=1&id=0ec82400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec82400",
  null
  
)

export default component.exports